import { Injectable, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { ExamsService } from './exams.service';
import  gastroDiagnosisList  from './../assets/tables/gastroDiagnosis.json'
import { Subject, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AutotextService } from './autotext.service';


@Injectable({
  providedIn: 'root'
})
export class GastroService implements OnDestroy{

  gastroForm: UntypedFormGroup;
  awlForm:UntypedFormGroup
  diagnosis= [];
  diagnosisChange$ = new Subject<void>();
  diag1:any;
  sub = new Subscription();
  last;

  summaryDiagnosisAT;
  detailsFinding=[
    {name:'Terminal ileum',db:"Terminal", value: 0, comment:null},
    {name:'Caecum',db:"Caecum", value: 0, comment:null},
    {name:'Ascending colon',db:"AscendingC", value: 0, comment:null},
    {name:'Hepatic flexure',db:"HepaticF", value: 0, comment:null},
    {name:'Transverse colon',db:"TransverseC", value: 0, comment:null},
    {name:'Splenic flexure',db:"SplenicF", value: 0, comment:null},
    {name:'Descending colon',db:"DescendingC", value: 0, comment:null},
    {name:'Sigma',db:"Sigma", value: 0, comment:null},
    {name:'Recto Sigma',db:"RectoS", value: 0, comment:null},
    {name:'Rectum',db:"Rectum", value: 0, comment:null},
    {name:'Anus',db:"Anus", value: 0, comment:null}
  ];
  recoverySTR=`המטופל משתחרר כשהוא מתמצא בזמן ובמקום, רפלקס בליעה ושיעול שמורים\nמצב המודינמי יציב, ללא בחילות הקאות או כאבי בטן משמעותיים.`
  dissmissionSTR=`יש לחזור הביתה בליווי, למנוחה של מספר שעות. עקב קבלת הטשטוש חל איסור מוחלט על נהיגה בשמונה השעות הקרובות.\nייתכן ויהיו לך תופעות של אי נוחות -נפיחות, כאב בטן, גזים ,דימום קל. אלו תופעות מוכרות ולרוב אינן מעוררות דאגה. אם יופיעו אחד מהסימנים הבאים: כאב חזק מהרגיל בבטן, עליית חום, דימום ממערכת העיכול, צואה שחורה, או דם בצואה (למעט שרידי דם בניגוב דם ודם לאחר פעולת מעיים), נמליץ לך לפנות מיד לחדר המיון הקרוב למקום מגוריך, כאשר בידך דו"ח הבדיקה.\nבמידה ונלקחו ביופסיות במהלך הבדיקה, מומלץ מעקב אחרי תוצאות הביופסיות דרך הרופא המטפל/ המפנה.`



  constructor(private http:HttpClient,private fb:UntypedFormBuilder, public es:ExamsService, private atS:AutotextService) {
    this.resetForm();
    this.resetAwl()
    this.sub = this.es.examLoaded$.subscribe(() => {
      this.resetForm();
      this.resetAwl()
      if(this.es.ExamType =='Colonoscopy' || this.es.ExamType=='Gastroscopy' || this.es.ExamType == 'Sigmoidoscopy' || this.es.ExamType === 'Abdomen US' || this.es.ExamType === 'Hemorrhoids Treatment')
        this.es.fillForm(this.gastroForm, "gastro", false, true,['inputControl']);
        this.es.fillAwlForm(this.awlForm,'AwlSchedule')
      this.buildList();
      if(es.isClosed){
        this.gastroForm.disable({emitEvent:false})
      }
    })
   }

   resetForm(){
     this.gastroForm = this.fb.group({
      Equipment: [''],
      ReffDoc: [''],
      Reasone : [''],
      Comments: [''],
      ExtentOfExam: [''],
      Medication: [''],
      FindingsComment:[''],
      PathologyComments:[''],
      Unit:[''],
      Dose: [''],
      imag1:[''],
      imag2:[''],
      scope1:[''],
      scope2:[''],
      Preparetion: [''],
      Colonoscopy:[''],
      ColoComment: [''],
      DignosisTree:[''],
      Diagnosis:[''],
      Recovery:[''],
      Recomm:[''],
      Esophagus:[''],
      EsophagusComment:[''],
      Stomach:[''],
      StomachComment:[''],
      Duodenum:[''],
      DuodenumComment:[''],
      EsoJunction:[''],
      Terminal: [''],
      TerminalComment:[''],
      Caecum: [''],
      CaecumComment:[''],
      AscendingC: [''],
      AscendingCComment:[''],
      HepaticF: [''],
      HepaticFComment:[''],
      TransverseC: [''],
      TransverseCComment:[''],
      SplenicF: [''],
      SplenicFComment:[''],
      DescendingC: [''],
      DescendingCComment:[''],
      Sigma: [''],
      SigmaComment:[''],
      RectoS: [''],
      RectoSComment:[''],
      Rectum: [''],
      RectumComment:[''],
      HMO: [''],
      OtherStaff:[''],
      ASA:[''],
      BBPS:[''],
      Mellampeti:[''],
      Dissmission:[''],
      TimeOut:[''],
      Quality:[''],
      inputControl:[''],
      Anus:[''],
      AnusComment:[''],
      EsoJunctionComment:[''],
      MedicalHistory:[''],
      ReasonExamination:[''],
      Liver:[''],
      RetroPeritoneum:[''],
      Gallbladder:[''],
      AbdominalAorta:[''],
      BiliaryTract:[''],
      Kidneys:[''],
      Pancreas:[''],
      Bladder:[''],
      Intestine:[''],
      Prostate:[''],
      Summary:[''],
      ProcedureResult:[''],
      Hp:[''],
      HpComment:[''],
      Spleen:[''],
      MedicalBackground:[''],
     })
   }


   
   resetAwl(){
    this.awlForm = this.fb.group({
      HMO:[''],
      AutoIndex:[''],
      refDocLastName:[''],
      BranchProviderName:[''],
      BranchProviderID:[''],
      refDocName:[''],
      Code:[''],
      PRN:[''],
      PRN2:[''],
      ExamCode:[''],
      Code2:[''],
      refDocName2:[''],
      BranchProviderID2:[''],
      BranchProviderName2:[''],
      refDocLastName2:['']
     
   
    })
  }

   buildList(data = this.gastroForm.get('DignosisTree').value, callback?){
      this.getATS(()=>{//wait until loaded
        this.diagnosis=[]
       var diagnosisNum: string[] =[];
       if(data){
         diagnosisNum = data.split(',');
         diagnosisNum.forEach((i) => {
           if(i)
            if(+i < gastroDiagnosisList.length)
              this.diagnosis.push({index:i, value:gastroDiagnosisList[i].value})
            else
              this.diagnosis.push({index: i, value: this.getTextsWithID(i)})
         })
       }
       if(callback)
         callback();
      });  
   }

   deleteDiagnosis(index:number){
     if(this.es.isClosed)
      return;
     var t ="";
     if(this.diagnosis && index < this.diagnosis.length){
      this.diagnosis.splice(index, 1);
      t= this.diagnosis.length === 1 ? this.diagnosis[0].index : '';
      if(this.diagnosis.length >1){
        this.diagnosis.forEach((i) => {
          if(t === ''){
            t=i.index
          }else{
            t = t+','+i.index;
          }
        })
      }
      this.gastroForm.get('DignosisTree').patchValue(t);
      this.diagnosisChange$.next(void 0);

    }
   }
   saveDiagnosis(item = this.diag1, addnew = false){
      if(item.value !== ''){
          this.last = item
          var index;
          if(addnew)
            index = gastroDiagnosisList.length
          else
            index = gastroDiagnosisList.indexOf(item).toString()
        if(!this.gastroForm.get('DignosisTree').value){
         this.gastroForm.get('DignosisTree').setValue(index.toString())
        }else if(this.gastroForm.get('DignosisTree').value == ''){
         this.gastroForm.get('DignosisTree').setValue(index.toString())
        }else{

         if(item && index != -1){
           var t = this.gastroForm.get('DignosisTree').value;
           if(! t.split(',').includes(index.toString())){
             t += ','+index;
             this.gastroForm.get('DignosisTree').patchValue(t);
           }
         }
        }
        this.diag1 ="";
        this.diagnosisChange$.next(void 0);
        // }
     }
  }

  ngOnDestroy(): void {
      this.sub.unsubscribe()
  }


  getFindings(data){
    var temp = [];
    this.detailsFinding.forEach((i) => {
      i.value = data[i.db];
      i.comment = data[i.db+'Comment']
      if(i.value > -1){
        temp.push(i);
      }
    })
    return temp;
  }
  getATS(callback?){
    let res = this.http.get('/api/autotext',{params:{field:'89'}});
    res.subscribe((data) => {
      this.summaryDiagnosisAT = data;
      if(callback)
        callback();
    })
  }

  getTextsWithID(id){
    if(this.last)
      return this.last.text;
    else
      return this.summaryDiagnosisAT[id - 130].Text;
  }

  getPatients(){
    return this.http.get('/api/gastro/GetTodayPatients');
  }
  getExams(PID:number){
    return this.http.get(`/api/gastro/GetExams/${PID}`);
  }

  signExam(signer){
    return this.http.post('/api/gastro/close/'+ this.es.examID,{'signer': signer});
  }
  getClosing(){
    return this.http.get('/api/gastro/closing/' + this.es.examID);
  }

  saveSign(form){
     return this.http.post('/api/gastro/saveSign', {form: form, examid:this.es.examID})
  }
  getAllSigns(){
    return this.http.get('/api/gastro/getAllSigns/'+this.es.examID);
  }

  printCourseOfExam(print: boolean): any {
    return this.http
      .get(`/api/gastro/printCourseOfExam/${print}/${this.es.examID}`)
      .subscribe((data) => {});
  }

  printCourseOfExamStatus(): any {
    return this.http.get(
      `/api/gastro/printCourseOfExamStatus/${this.es.examID}`
    );
  }


  labResults(
    status: string,
    lab: string,
    uid: string | number,
    page?: number,
    pageSize?: number,
  ) {
    let params: { [param: string]: string | number } = {};
    if (uid && uid != "null") {
      params["uid"] = uid;
    }
    if (lab) {
      params["lab"] = lab;
    }
    if (page) {
      params["page"] = page;
    }
    if (pageSize) {
      params["pageSize"] = pageSize;
    }
    return this.http.get("/api/gastro/labresults/" + status, {
      params: params,
    });
  }

  getLabResultPdf(resultid){
    return this.http.get('/api/gastro/labresultpdf/' + resultid, { responseType: 'arraybuffer' });
  }

  getInventoryReportPdf(inventoryId){
    return this.http.get('/api/lab/inventoryreportpdf/' + inventoryId, { responseType: 'arraybuffer' });
  }

  getUnreadLabReports(){//for this doctor
    return this.http.get('/api/lab/unreadlabreports');
  }

}
